<template>
    <div class="message-create mb-3 mt-page">

        <data-form :title="$i18n.gt('HEADING_CREATE_MESSAGE')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="messageFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_MESSAGE_CREATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_CREATING_MESSAGE')"
                   :submit-success-route="successRoute"
                   :cancel-route="successRoute">

            <!-- message preview -->

            <template v-slot:preview="slotProps">
                <b-row class="mx-5 mt-4">
                    <b-col>
                        <message-preview to-name="[Name]"
                                         :subject="slotProps.$v.form.subject.$model"
                                         :body="slotProps.$v.form.body.$model">
                        </message-preview>
                    </b-col>
                </b-row>
            </template>

        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import MessageFields from '@/models/Message'

/**
 * Page to create a Message for a Practice
 */
export default Vue.extend({
    name: "MessageCreate",
    props: {
        practiceId: Number
    },
    data() {
        return {
            messageFields: MessageFields,
            fieldGroups: [
                ['name', 'subject', 'body'],
            ],
            message: null
        }
    },
    computed: {
        successRoute() {
            return `/practice/messages/id/${this.practiceId}`
        },
    },
    methods: {
        loadModelInstance() {
            return new Promise((resolve, reject) => {
                const message = {
                    practice_id: this.practiceId
                }
                this.message = message
                resolve(message)
            })
        },
        onSubmit(modelInstance) {
            return this.$api.createItem(this, 'message', modelInstance)
        }
    }
})

</script>
